import CustomerStorySmallCard from "@components/BasicComponents/Cards/CustomerStory/CustomerStorySmallCard"
import PaginationWithFiltes from "@components/BasicComponents/PaginationWithFiltes/PaginationWithFiltes"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	CategoryModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"

import styles from "./CustomerStoriesVerticalList.module.scss"

type Props = {
	data: CustomerStoryModuleType[]
	useCases: CategoryModuleType[]
	industries: CategoryModuleType[]
	pageData: AdvancedSideAssetModuleType
}

const CustomerStoriesVerticalList = (props: Props) => {
	const [stories, setStories] = useState<CustomerStoryModuleType[]>(
		props.data,
	)

	const changeStories = (data: any[]) => {
		setStories(data)
	}

	return (
		<section>
			<Separator backgroundColor={"#F8FAFE"}>
				<Separator />

				<ContainerWrapper>
					<Typography
						content={props.pageData.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					<Typography
						style={{
							maxWidth: "1024px",
							marginTop: "1.5rem",
						}}
						content={props.pageData.sectionSubtitle}
						variant={Variant.SectionSubtitle}
					/>
					<Separator />
					<PaginationWithFiltes
						changeData={changeStories}
						data={props.data}
						filters={[
							{Industries: {options: props.industries}},
							{"Use Cases": {options: props.useCases}},
						]}
						postType={"Customer Stories"}
						stylesForFilterBox={styles.cardContainer}
						stylesForFilters={styles.cardBox}
					>
						<Separator className={styles.cardContainer}>
							{stories?.map(
								(
									element: CustomerStoryModuleType,
									index: number,
								) => {
									return (
										<CustomerStorySmallCard
											key={index}
											className={styles.cardBox}
											data={element}
										/>
									)
								},
							)}
						</Separator>
					</PaginationWithFiltes>
				</ContainerWrapper>
				<Separator />
			</Separator>
		</section>
	)
}

export default CustomerStoriesVerticalList
